import { fetchPaymentTermList } from '#/api/system/paymentTerm/fetchList';

export function mapPaymentTermRowsToSelectOptions(rows = []) {
  return rows.map((row) => ({
    value: row.id,
    label: [row.code, row.name].filter(Boolean).join(' - ') || String(row.id),
  }));
}

/**
 * ACTIVE 付款條件 select options（採購等）。
 * Label：`{code} - {name}`；`lookupQueryKey('paymentTermSelect')`。
 */
export async function fetchPaymentTermSelectOptions() {
  const { data } = await fetchPaymentTermList({
    page: 1,
    pageSize: 200,
    keyword: '',
    sort: [{ id: 'code', desc: false }],
    filters: { status: 'ACTIVE' },
  });

  return mapPaymentTermRowsToSelectOptions(data ?? []);
}
